import React, { useState, useEffect } from 'react';

// Vraies captures des outils, en boucle animée (fondu + léger zoom) dans une fenêtre navigateur.
const SLIDES = [
  { src: '/showcase/diagnostic.jpg', label: 'Fiche Diagnostic' },
  { src: '/showcase/cotation.jpg', label: 'Cotation CCAM / NGAP' },
  { src: '/showcase/scores.jpg', label: 'Scores Médicaux' },
];

export const ToolShowcase = () => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % SLIDES.length), 3200);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="mb-6" data-testid="hero-tool-showcase">
      <p className="text-[11px] uppercase tracking-[0.2em] text-slate-400 mb-2">Les outils en action</p>

      <div className="rounded-xl overflow-hidden border border-white/10 bg-slate-900/70 backdrop-blur-sm shadow-2xl shadow-black/50">
        {/* barre de fenêtre */}
        <div className="flex items-center gap-1.5 px-3 py-2 border-b border-white/10 bg-slate-950/60">
          <span className="w-2.5 h-2.5 rounded-full bg-red-400/70" />
          <span className="w-2.5 h-2.5 rounded-full bg-amber-400/70" />
          <span className="w-2.5 h-2.5 rounded-full bg-emerald-400/70" />
          <span className="ml-2 text-[11px] text-slate-300 font-medium" data-testid="showcase-label">{SLIDES[i].label}</span>
        </div>
        {/* captures en fondu + zoom */}
        <div className="relative bg-slate-950" style={{ aspectRatio: '960 / 376' }}>
          {SLIDES.map((s, idx) => (
            <img
              key={s.src}
              src={s.src}
              alt={s.label}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ease-out"
              style={{ opacity: idx === i ? 1 : 0, animation: idx === i ? 'tsZoom 3.4s ease-out both' : 'none' }}
            />
          ))}
        </div>
      </div>

      {/* progression cliquable */}
      <div className="flex justify-center gap-1.5 mt-2.5">
        {SLIDES.map((s, idx) => (
          <button
            key={s.src}
            onClick={() => setI(idx)}
            aria-label={s.label}
            data-testid={`showcase-dot-${idx}`}
            className={`h-1.5 rounded-full transition-all duration-300 ${idx === i ? 'w-6 bg-cyan-400' : 'w-1.5 bg-white/25 hover:bg-white/40'}`}
          />
        ))}
      </div>

      <style>{`
        @keyframes tsZoom { from { transform: scale(1.06); } to { transform: scale(1); } }
      `}</style>
    </div>
  );
};
